/*global jQuery*/
(function ($) {
    'use strict';

    function SocialOverlayToggle(element, options) {
        this.init(element, options);
    }

    SocialOverlayToggle.prototype = {
        constructor: SocialOverlayToggle,

        // Properties
        overlayId: null,

        // Methods
        init: function (element, options) {
            var $element = $(element);

            this.options = options;
            this.overlayId = $element.data('social-overlay');

            if (this.overlayId && this.overlay().length) {
                // Initialize only if there is an overlay for this menu entry
                $element.on('click', this.showOverlay.bind(this));
            }
        },

        showOverlay: function (e) {
            if (e) {
                e.preventDefault();
            }

            this.overlay().removeClass('hidden');
        },

        hideOverlay: function (e) {
            if (e) {
                e.stopPropagation();
                e.preventDefault();
            }

            this.overlay().addClass('hidden');
        },

        overlay: function () {
            var $overlay = $('#' + this.overlayId);

            if ($overlay.length) {
                var isInitialized = $overlay.data('initialized');

                if (!isInitialized) {
                    $overlay.data('initialized', true);
                    $overlay.on('click', '.social-overlay__close', this.hideOverlay.bind(this));
                }
            }

            return $overlay;
        }
    };

    ////////////////////

    $.fn.socialOverlayToggle = function (option/*, varArgs*/) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var $element = $(this);
            var ctrl = $element.data('socialOverlayToggle');

            if (!ctrl) {
                var opts = $.extend({},
                    $.fn.socialOverlayToggle.defaults,
                    typeof option == 'object' && option
                );

                $element.data('socialOverlayToggle', (ctrl = new SocialOverlayToggle(this, opts)));
            }

            if (typeof option == 'string') {
                ctrl[option].apply(ctrl, args);
            }
        });
    };

    $.fn.socialOverlayToggle.defaults = {};
})(jQuery);
